<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.cliente"
        ref="RkmDataTable"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                v-if="authorize('cadastro-cliente-update')"
                :to="{name: 'cadastro-cliente-edit', params: {id: item.cliente_id}}"
                color="primary"
                small
                title="Editar"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                v-if="authorize('cadastro-cliente-destroy')"
                @click="handleDestroy(item)"
                color="danger"
                small
                title="Excluir"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {authorization, error, notification} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {key: 'sistema_nome', label: 'Sistema', name: 'cadastro_sistema.nome', searchable: true, sortable: true},
                {key: 'municipio_nome', label: 'Município', name: 'cadastro_municipio.nome', searchable: true, sortable: true},
                {key: 'cliente_nome', label: 'Nome', name: 'cadastro_cliente.nome', searchable: true, sortable: true},
                {key: 'cliente_link', label: 'Link', name: 'cadastro_cliente.link', searchable: true, sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ]
        },
    },
    inject: ['repositories'],
    methods: {
        handleDestroy(item) {
            const destroy = () => this.repositories.cadastro.cliente.destroy(item.cliente_id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDangerConfirmation('Confirmação', `Deseja realmente excluir a cliente ${item.cliente_nome}?`, destroy, this.handleError)
        },
    },
    mixins: [authorization, error, notification],
}
</script>